import _ from 'underscore';

export const Campaign = {
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Campaign',
    },
    Name: {
      'bulk-upload-header': 'Campaign',
    },
    CampaignSubType: {
      'bulk-upload-header': 'Sub Type',
    },
    TrackingUrlTemplate: {
      'bulk-upload-header': 'Tracking Template',
      bulkDeleteValueIfEmpty: true,
    },
    UrlCustomParameters: {
      'bulk-upload-header': 'Custom Parameter',
      'bulk-upload-mapper': function (value) {
        return _.map(value, p => `{_${p.Key}}=${p.Value}`).join('; ');
      },
      bulkDeleteValueIfEmpty: true,
    },
    FinalUrlSuffix: {
      'bulk-upload-header': 'Final Url Suffix',
      bulkDeleteValueIfEmpty: true,
    },
    BudgetId: {
      'bulk-upload-header': 'Budget Id',
    },
    BudgetName: {
      'bulk-upload-header': 'Budget Name',
    },
    TimeZone: {
      'bulk-upload-header': 'Time Zone',
    },
    AdScheduleUseSearcherTimeZone: {
      'bulk-upload-header': 'Ad Schedule Use Searcher Time Zone',
    },
    Languages: {
      filterable: true,
      'bulk-upload-header': 'Language',
      'bulk-upload-mapper': function (value) {
        return value.join(';');
      },
    },
    NativeBidAdjustment: {
      'bulk-upload-header': 'Bid Adjustment',
    },
    MultimediaAdBidAdjustment: {
      'bulk-upload-header': 'Multi Media Ad Bid Adjustment',
    },
    CampaignType: {
      'bulk-upload-header': 'Campaign Type',
      'bulk-upload-mapper': function (value) {
        if (value === 'DynamicSearchAds') {
          return 'Dynamic Search';
        }
        return value;
      },
    },
    DomainName: {
      'bulk-upload-header': 'Website',
    },
    LanguageCode: {
      'bulk-upload-header': 'Domain Language',
    },
    Source: {
      'bulk-upload-header': 'Source',
    },
    DynamicDescriptionEnabled: {
      'bulk-upload-header': 'Dynamic Description Enabled',
    },
    TargetSetting: {
      'bulk-upload-header': 'Target Setting',
    },
    DisclaimerAdsEnabled: {
      'bulk-upload-header': 'Disclaimer Ads Enabled',
    },
    BidStrategyId: {
      'bulk-upload-header': 'Bid Strategy Id',
    },
    BidStrategyName: {
      'bulk-upload-header': 'Bid Strategy Name',
    },
    CashbackMonthlyBudget: {
      'bulk-upload-header': 'Cashback Monthly Budget',
    },
    CashbackPercent: {
      'bulk-upload-header': 'Cashback Percent',
    },
    CashbackScope: {
      'bulk-upload-header': 'Cashback Scope',
    },
    PersonalizedOffersEnabled: {
      'bulk-upload-header': 'Personalized Offers Enabled',
    },
    CouponsEnabled: {
      'bulk-upload-header': 'Personalized Coupons Enabled',
    },
    VerifiedTrackingData: {
      'bulk-upload-header': 'Verified Tracking Setting',
    },
    SalesCountry: {
      'bulk-upload-header': 'Country Code',
    },
    LocalInventoryAdsEnabled: {
      'bulk-upload-header': 'Local Inventory Ads Enabled',
      'bulk-upload-mapper': function (value) {
        return value ? 'true' : 'false';
      },
    },
    Priority: {
      'bulk-upload-mapper': function (value) {
        const mapping = {
          Low: 0,
          Medium: 1,
          High: 2,
          Highest: 3,
        };

        return mapping[value];
      },
    },
    ProviderId: {
      'bulk-upload-header': 'Store Id',
    },
    IsLeadGenCampaign: {
      'bulk-upload-header': 'Is Lead Gen Campaign',
    },
  },
};
